import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../utils/api.types";
import { resetPassword, forgotPassword } from './passwordThunk';

interface IPasswordSliceState {
    status: ApiStatus
    errorMessage: string;
    message: string;
}

const initialState: IPasswordSliceState = {
   status: ApiStatus.IDLE,
    message: '',
    errorMessage: '',
}

/**
 * Reset Password Slice.
 */
const passwordSlice = createSlice({
    name: 'password',
    initialState: initialState,
    reducers: {
        clearState: (state) => {
            state.status = ApiStatus.IDLE;
            state.errorMessage = '';
            state.message = '';
      
            return state;
        },
    },
    extraReducers: (builder) => {
        builder
            // Reset Password.
            .addCase(resetPassword.pending, (state) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(resetPassword.fulfilled, (state, action) => {
                setStateOnSuccess(state, action.payload.message);
            })
            .addCase(resetPassword.rejected, (state) => {
                setStateOnReject(state);
            })
            // Forgot Password
            .addCase(forgotPassword.pending, (state) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(forgotPassword.fulfilled, (state, action) => {
                setStateOnSuccess(state, action.payload.message);
            })
            .addCase(forgotPassword.rejected, (state) => {
                setStateOnReject(state);
            })
    }
});

/**
 * Method to set password state when api call is success.
 * @param state 
 * @param message 
 */
const setStateOnSuccess = (state: IPasswordSliceState, message: string) => {
    state.message = message;
    state.status = ApiStatus.SUCCESS;
    state.errorMessage = '';

    toast.success(message);
}

/**
 * Method to set password state when api is failed.
 * @param state
 */
const setStateOnReject = (state: IPasswordSliceState) => {
    state.status = ApiStatus.FAILED;
}

export const { clearState } = passwordSlice.actions;

export default passwordSlice.reducer;
